// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

document.addEventListener('turbo:load', () => {
  [].slice
    .call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    .map((e) => new bootstrap.Tooltip(e));

  [].slice
    .call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    .map(e => new bootstrap.Popover(e));
})
